// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".downError_message_dialog[data-v-0654fcbe]{position:absolute;top:0;right:0;bottom:0;left:0;padding-top:35px;text-align:center}.downError_message_dialog .downError_message_title[data-v-0654fcbe]{position:relative;top:0;font-size:16px;font-weight:400;color:#333;text-align:center}.downError_message_dialog .downError_message_btn[data-v-0654fcbe]{position:relative;top:30px}", ""]);
// Exports
module.exports = exports;
